import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="planes" className="w-full bg-white py-16 md:py-24" data-id="element-154" data-mp="2jke8il6jomw5">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-155" data-mp="1vv39b84uf0k4">
        {showUrgency && <CountdownPanel data-id="element-156" data-mp="1rsyisi9oyk1p" />}

        <h2 className="mt-16 text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-157" data-mp="1rtrmtbh9mvg5">
          Il tuo investimento nell'<span className="text-blue-600" data-id="element-158" data-mp="20t4rzrycwxv2">Atlante Visivo</span>
        </h2>

        <div className="mx-auto mt-10 max-w-4xl rounded-2xl bg-white p-7 shadow-lg ring-2 ring-blue-600 md:p-10" data-id="element-159" data-mp="20v7qz1hhm1bx">
          <p className="text-center text-xl font-extrabold uppercase tracking-tight text-slate-900 md:text-2xl" data-id="element-160" data-mp="3c8a5zs3xuitz">
            {offer.name}
          </p>
          <p className="mt-2 text-center text-lg text-blue-900/75" data-id="element-161" data-mp="3vynjyjmxk5d1">{offer.summary}</p>

          <ul className="mx-auto mt-8 grid max-w-xl gap-4 text-left sm:grid-cols-2" data-id="element-162" data-mp="4s4b3a0nmphd">
            {offer.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-163" data-mp="9t0b3chvxrhi">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600" data-id="element-164" data-mp="eqaa9jv2thij">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="3d6up0joawa2o" />
                </span>
                <span className="text-slate-900" data-id="element-166" data-mp="3i8bpwf6sbwj9">{item}</span>
              </li>)}
          </ul>

          <div className="mt-10 text-center" data-id="element-167" data-mp="3n5238ur7ge0z">
            <p className="text-lg text-blue-900/45" data-id="element-168" data-mp="3ry3mfeyg2zqd">
              Valore totale <span className="line-through" data-id="element-169" data-mp="2uihd1xmgu7z0">{offer.listPrice}</span>
            </p>
            <p className="text-5xl font-extrabold tracking-tight text-slate-900 md:text-6xl" data-id="element-170" data-mp="2ugdabj0azf0b">
              {offer.price}
              <span className="ml-2 text-xl font-semibold text-blue-900/55" data-id="element-171" data-mp="2rguxj7e7tkak">{offer.currency}</span>
            </p>
            <p className="mt-3 inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm font-bold text-emerald-600" data-id="element-172" data-mp="2mibf3gytyqmy">
              <span className="rounded-lg bg-emerald-50 px-3 py-1 uppercase tracking-wide" data-id="element-173" data-mp="3164t4x89pl3f">
                {offer.discount}
              </span>
              <span className="text-blue-900/70" data-id="element-174" data-mp="28i0ngbpp580q">Risparmi {offer.savings}</span>
            </p>
          </div>

          <div className="mt-8" data-id="element-175" data-mp="23j5vaj5ua73y">
            <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-176" data-mp="23k7fbd4u23xt">
              {offer.cta}
            </CtaButton>
            <p className="mt-3 text-center text-sm text-blue-900/60" data-id="element-177" data-mp="2ihhqsmhh79tj">{offer.note}</p>
          </div>

          <p className="mt-4 text-center text-sm text-blue-900/60" data-id="element-178" data-mp="2dfsez4mfis4e">{offer.details}</p>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-179" data-mp="3txg4j3nlmk13">
          <li className="inline-flex items-center gap-2" data-id="element-180" data-mp="adnax2mu5m6">
            <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-181" data-mp="8ssd6ceokns" /> Pagamento sicuro
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-182" data-mp="5arvcf48hfk7">
            <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-183" data-mp="3nfv54d55afqy" /> Accesso immediato
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-184" data-mp="3rhq255g1m6yx">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-185" data-mp="j0v7uedb9uwg" /> Garanzia di
            7 giorni
          </li>
        </ul>
      </div>
    </section>;
}